"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Return the size of the icon in px from the theme props for standard sizes
 * Or calculate it based on the numerical size prop
 * @param {string|number} size
 * @param {object} theme
 * @returns number
 */
var getIconSizePx = function getIconSizePx(_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  if (typeof size === 'number') {
    // 2px larger than half the size of the Avatar
    return size / 2 + 2;
  }
  return theme["icon".concat(size[0].toUpperCase() + size.slice(1))];
};
var _default = getIconSizePx;
exports["default"] = _default;